export const configData =  {  

    APP_URL: "/basic/web/api/",
    DOMAIN_URL: "https://team.sportsmanagementworldwide.com/basic/web/",
    DRUPAL_APP_URL: "https://www.sportsmanagementworldwide.com/api/",
    DRUPAL_DOMAIN_URL: "https://www.sportsmanagementworldwide.com",
    AGENCY_DOMAIN_URL: "https://www.smwwagency.com",
    SCOUT_DOMAIN_URL: "https://www.smwwscout.com",
    RSMWW_DOMAIN: "team.sportsmanagementworldwide.com",
    RSMWW_AGENCY_DOMAIN: "www.smwwagency.com",
    RSMWW_SCOUT_DOMAIN: "www.smwwscout.com",
    RSMWW_AGENCY_URL: "https://www.smwwagency.com",
    RSMWW_SCOUT_URL: "https://www.smwwscout.com",
    RSMWW_URL: "https://team.sportsmanagementworldwide.com",
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeGtQoTAAAAAC7f3LyY82WLCfOH66NMbs9f6eNv',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`,
    ROLE_ADMINISTRATOR: 3,
    ROLE_SAADMIN: 8,
    ROLE_SALES_PEOPLE:10,
    ROLE_SALES_DIRECTOR:18,
    ROLE_APPLICATION:12,
    ROLE_GLOBAL_AMBASSADOR:26,
    ROLE_AGENT:6,
    ROLE_SCOUT:5,
    ROLE_ATHLETE:11,
    ROLE_MENTOR:7,
    ROLE_AUTHENTICATED_USER:2
     }